export function isDefined(object: string) {
	if (object === undefined || object === null) {
		return false
	}
	return true
}

export function getPublisherUrl(domainName: string, relativePath: string) {
	relativePath = relativePath.replace(/^\//, '')
	return domainName + relativePath
}

export function returnRTEHTML(rteString: string) {
	return document.createRange().createContextualFragment(rteString)
}

export function getFormattedNumber(unformattedString: number, locale?: string) {
	return unformattedString ? new Intl.NumberFormat(locale).format(unformattedString) : 0
}

export function sanitizeUrl(url: string) {
	return url.replace('[^-A-Za-z0-9+&@#/%?=~_|!:,.;()]', '')
}

export function isRTL(): boolean {
	return document.dir === 'rtl' ? true : false
}

export function isWebViewApp(): boolean {
	return navigator.userAgent.toLowerCase()?.indexOf('webview') != -1 ? true : false
}
